/*
  Cart drawer and cart page (Dair theme).
  - Product forms (action ".../cart/add") add via AJAX and open the drawer instead of reloading.
  - The header cart links open the drawer (except on the cart page itself).
  - Quantity steppers / remove links update the cart instantly in the drawer and on the cart page,
    re-rendering sections/cart-drawer.liquid and sections/main-cart.liquid via the Section Rendering API.
  Without JavaScript everything falls back to the normal cart page and forms.
*/
(function() {
  var drawer = document.querySelector('[data-pl-cart-drawer]');
  var DRAWER_SECTION = 'cart-drawer';
  // The store's upsell app injects "You may like this" at the top of open drawers;
  // keep it, but under the cart items so the header and checkout stay in place.
  var UPSELL = '#drawer_sellup_wrapper';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function cartPage() {
    return document.querySelector('[data-pl-cart-page]');
  }

  function sectionIds() {
    var ids = [];
    if (drawer) ids.push(DRAWER_SECTION);
    var page = cartPage();
    if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-link__bubble').forEach(function(bubble) {
      bubble.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  // Remember which control had focus so it can be restored after a re-render.
  function focusKey() {
    var el = document.activeElement;
    var line = el && el.closest && el.closest('[data-pl-line]');
    if (!line) return null;
    var attr = ['data-pl-qty-step', 'data-pl-qty-input', 'data-pl-remove'].filter(function(a) { return el.hasAttribute(a); })[0];
    if (!attr) return null;
    var inDrawer = !!el.closest('[data-pl-cart-drawer]');
    return { inDrawer: inDrawer, line: line.getAttribute('data-pl-line'), attr: attr, value: el.getAttribute(attr) };
  }

  function restoreFocus(key) {
    if (!key) return;
    var scope = key.inDrawer ? drawer : cartPage();
    if (!scope) return;
    var selector = '[data-pl-line="' + key.line + '"] [' + key.attr + (key.value ? '="' + key.value + '"' : '') + ']';
    var el = scope.querySelector(selector) || scope.querySelector('[data-pl-cart-close]');
    if (el) el.focus();
  }

  // Shipping progress: re-rendered markup jumps to the new width; animate from the old one.
  function fillWidth(scope) {
    var fill = scope && scope.querySelector('.pl-ship__fill');
    return fill ? fill.style.width : null;
  }

  function animateFill(scope, from) {
    var fill = scope && scope.querySelector('.pl-ship__fill');
    if (!fill || !from || fill.style.width === from) return;
    var to = fill.style.width;
    fill.style.transition = 'none';
    fill.style.width = from;
    void fill.offsetWidth;
    fill.style.transition = '';
    fill.style.width = to;
  }

  function renderSections(sections) {
    if (!sections) return;
    var key = focusKey();

    if (drawer && sections[DRAWER_SECTION]) {
      var fresh = parse(sections[DRAWER_SECTION]).querySelector('[data-pl-cart-content]');
      var current = drawer.querySelector('[data-pl-cart-content]');
      if (fresh && current) {
        var drawerFill = fillWidth(drawer);
        // Keep the list where it was scrolled to (e.g. after changing a quantity further down);
        // read it before the upsell block comes out and shortens the list.
        var oldBody = current.querySelector('.pl-drawer__body');
        var scrollTop = oldBody ? oldBody.scrollTop : 0;
        var upsell = drawer.querySelector(UPSELL);
        if (upsell) upsell.remove();
        // Keep a note that's being typed (and its open state) across the re-render.
        var oldNote = current.querySelector('[data-pl-cart-note]');
        var freshNote = fresh.querySelector('[data-pl-cart-note]');
        if (oldNote && freshNote) {
          freshNote.value = oldNote.value;
          freshNote.closest('details').open = oldNote.closest('details').open;
          syncNoteLabel(freshNote);
        }
        current.replaceWith(fresh);
        if (upsell) placeUpsell(upsell);
        var freshBody = fresh.querySelector('.pl-drawer__body');
        if (freshBody && scrollTop) {
          freshBody.scrollTop = scrollTop;
          holdScroll(scrollTop);
        }
        balanceLines();
        updateScrollCues();
        animateFill(drawer, drawerFill);
        updateBubble(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
      }
    }

    var page = cartPage();
    var pageId = page && page.getAttribute('data-section-id');
    if (page && sections[pageId]) {
      var doc = parse(sections[pageId]);
      var freshPage = doc.querySelector('[data-pl-cart-page]');
      // Empty cart: swap the whole section to show the empty state.
      if (!freshPage.querySelector('[data-pl-cart-items]')) {
        page.replaceWith(freshPage);
      } else {
        // Replace items and totals only, so the express checkout buttons stay initialised.
        var pageFill = fillWidth(page);
        ['[data-pl-cart-items]', '[data-pl-cart-totals]', '[data-pl-cart-count]', '[data-pl-cart-bar-total]', '[data-pl-ship]'].forEach(function(selector) {
          var a = page.querySelector(selector);
          var b = freshPage.querySelector(selector);
          if (a && b) a.replaceWith(b);
        });
        animateFill(page, pageFill);
      }
    }

    restoreFocus(key);
  }

  function requestJSON(url, options) {
    options.headers = Object.assign({ Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-PL-Cart': '1' }, options.headers || {});
    return fetch(url, options).then(function(response) {
      return response.json().then(function(data) {
        return { ok: response.ok, data: data };
      });
    });
  }

  /* ---------- Drawer ---------- */

  function placeUpsell(upsell) {
    upsell = upsell || (drawer && drawer.querySelector(':scope > ' + UPSELL));
    var body = drawer && drawer.querySelector('.pl-drawer__body');
    if (!upsell || upsell.parentNode === body) return;
    if (body) body.appendChild(upsell);
    else upsell.remove();
  }

  // After a re-render the upsell app removes and re-adds its block, which briefly shortens the
  // list and pulls the scroll position up; put it back once the block returns, unless the
  // shopper has scrolled since.
  var keepScroll = null;
  var keepTimer;

  function holdScroll(top) {
    keepScroll = top;
    clearTimeout(keepTimer);
    keepTimer = setTimeout(function() { keepScroll = null; }, 2500);
  }

  function reapplyScroll() {
    var parts = scrollParts();
    if (parts && keepScroll !== null && parts.body.scrollTop !== keepScroll) parts.body.scrollTop = keepScroll;
  }

  if (drawer) {
    new MutationObserver(function() {
      placeUpsell();
      reapplyScroll();
      updateScrollCues();
    }).observe(drawer, { childList: true });
    ['wheel', 'touchmove', 'keydown'].forEach(function(type) {
      drawer.addEventListener(type, function() { keepScroll = null; }, { passive: true });
    });
  }

  // Scroll cues: a fade at the bottom of the list while there's more below, so the next item
  // peeks out from under it, and a soft shadow at the top once the list is scrolled.
  // When the list happens to end right between two items (nothing peeking), the fade starts
  // higher, over the last item's quantity controls, so that item reads as the preview instead.
  var PEEK = 48;

  function scrollParts() {
    var wrap = drawer && drawer.querySelector('[data-pl-drawer-scroll]');
    var body = wrap && wrap.querySelector('.pl-drawer__body');
    return body ? { wrap: wrap, body: body } : null;
  }

  function fadeHeight(body) {
    if (body.scrollTop > 2) return null;
    var bottom = body.clientHeight;
    var lines = body.querySelectorAll('[data-pl-line]');
    for (var i = 1; i < lines.length; i++) {
      var next = lines[i];
      if (next.offsetTop + next.offsetHeight <= bottom + 1) continue;
      if (bottom - next.offsetTop >= PEEK) return null;
      var last = lines[i - 1];
      var controls = last.querySelector('.pl-line__controls');
      var start = last.offsetTop + (controls ? controls.offsetTop - 6 : last.offsetHeight / 2);
      return Math.max(72, Math.min(160, Math.round(bottom - start)));
    }
    return null;
  }

  // Spacing between items is tuned (8–30px, default 16px) so the list ends partway through the
  // next item: its photo and title peek out from under the fade, so it's obvious there's more.
  // Only done while the list is at the top, so nothing moves under the shopper while scrolling.
  var PAD = 16;
  var PAD_MIN = 8;
  var PAD_MAX = 30;

  function balanceLines() {
    var parts = scrollParts();
    if (!parts || !drawer.open || parts.body.scrollTop > 2) return;
    var body = parts.body;
    var lines = Array.prototype.slice.call(body.querySelectorAll('[data-pl-line]'));
    var current = lines.length ? parseFloat(getComputedStyle(lines[0]).paddingTop) || PAD : PAD;
    var content = lines.map(function(line) { return line.offsetHeight - 2 * current; });
    var visible = body.clientHeight;
    var total = content.reduce(function(sum, h) { return sum + h + 2 * PAD; }, 0);
    var best = null;
    if (lines.length > 1 && total > visible) {
      var above = 0;
      for (var k = 1; k < lines.length; k++) {
        above += content[k - 1];
        var target = Math.min(84, Math.max(56, Math.round((content[k] + 2 * PAD) * 0.55)));
        var pad = Math.min(PAD_MAX, Math.max(PAD_MIN, (visible - above - target) / (2 * k)));
        var peek = visible - above - 2 * pad * k;
        if (peek >= 44 && peek <= content[k] + 2 * pad - 24 && (!best || Math.abs(pad - PAD) < Math.abs(best - PAD))) best = pad;
      }
    }
    if (best === null) drawer.style.removeProperty('--pl-line-pad');
    else drawer.style.setProperty('--pl-line-pad', (Math.round(best * 2) / 2) + 'px');
  }

  function updateScrollCues() {
    var parts = scrollParts();
    if (!parts || !drawer.open) return;
    var body = parts.body;
    var more = body.scrollHeight - body.scrollTop - body.clientHeight > 4;
    parts.wrap.classList.toggle('is-scrolled', body.scrollTop > 2);
    parts.wrap.classList.toggle('has-more', more);
    var fade = more ? fadeHeight(body) : null;
    if (fade) parts.wrap.style.setProperty('--pl-fade', fade + 'px');
    else parts.wrap.style.removeProperty('--pl-fade');
  }

  // Bring the line just added into view and flash it.
  function showAdded(key) {
    var parts = scrollParts();
    var line = parts && key && parts.body.querySelector('[data-pl-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (!line) return;
    var body = parts.body;
    if (line.offsetTop < body.scrollTop || line.offsetTop + line.offsetHeight > body.scrollTop + body.clientHeight) {
      body.scrollTop = Math.max(0, line.offsetTop - 12);
      holdScroll(body.scrollTop);
    }
    line.classList.remove('is-added');
    void line.offsetWidth;
    line.classList.add('is-added');
  }

  function openDrawer() {
    if (!drawer || drawer.open) return;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    document.documentElement.classList.add('pl-drawer-open');
    balanceLines();
    updateScrollCues();
  }

  function closeDrawer() {
    if (!drawer || !drawer.open) return;
    drawer.classList.add('is-closing');
    setTimeout(function() {
      drawer.close();
      drawer.classList.remove('is-closing');
    }, 220);
  }

  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch(root + '?sections=' + DRAWER_SECTION)
      .then(function(response) { return response.json(); })
      .then(renderSections)
      .catch(function() {});
  }

  if (drawer && typeof drawer.showModal === 'function') {
    drawer.addEventListener('close', function() {
      document.documentElement.classList.remove('pl-drawer-open');
    });
    drawer.addEventListener('cancel', function(evt) {
      evt.preventDefault();
      closeDrawer();
    });
    drawer.addEventListener('click', function(evt) {
      // Clicks on the backdrop land on the <dialog> itself.
      if (evt.target === drawer || evt.target.closest('[data-pl-cart-close]')) closeDrawer();
    });
    // Scroll events don't bubble; listening in the capture phase catches the list's scrolling
    // even after its markup is re-rendered.
    drawer.addEventListener('scroll', updateScrollCues, true);
    window.addEventListener('resize', function() {
      balanceLines();
      updateScrollCues();
    });

    document.addEventListener('click', function(evt) {
      var link = evt.target.closest && evt.target.closest('a.cart-link');
      if (!link || cartPage() || evt.metaKey || evt.ctrlKey) return;
      evt.preventDefault();
      openDrawer();
      refreshDrawer();
    });
  } else {
    drawer = null;
  }

  /* ---------- Add to cart ---------- */

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function formError(form, message) {
    var el = form.querySelector('[data-pl-form-error]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pl-form-error';
      el.setAttribute('data-pl-form-error', '');
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = message || '';
    el.hidden = !message;
  }

  document.addEventListener('submit', function(evt) {
    var form = evt.target;
    if (!drawer || !form.matches('form[action$="/cart/add"]') || form.hasAttribute('data-pl-no-drawer')) return;
    evt.preventDefault();

    var button = form.querySelector('[type="submit"][name="add"]') || evt.submitter;
    var body = new FormData(form);
    body.append('sections', sectionIds().join(','));
    body.append('sections_url', window.location.pathname);

    setBusy(button, true);
    requestJSON(root + 'cart/add.js', { method: 'POST', body: body })
      .then(function(result) {
        if (!result.ok) {
          formError(form, result.data.description || result.data.message || 'This item could not be added.');
          return;
        }
        formError(form, '');
        var added = result.data.key || (result.data.items && result.data.items[0] && result.data.items[0].key);
        if (result.data.sections) renderSections(result.data.sections);
        else refreshDrawer();
        openDrawer();
        showAdded(added);
        updateScrollCues();
      })
      .catch(function() {
        form.submit();
      })
      .then(function() {
        setBusy(button, false);
      });
  });

  /* ---------- Quantity and remove (drawer + cart page) ---------- */

  var pending = {};

  function changeLine(lineEl, quantity) {
    var line = lineEl.getAttribute('data-pl-line');
    if (pending[line]) return;
    pending[line] = true;
    lineEl.classList.add('is-updating');

    requestJSON(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity, sections: sectionIds(), sections_url: window.location.pathname })
    })
      .then(function(result) {
        if (!result.ok) {
          var error = lineEl.querySelector('[data-pl-line-error]');
          if (error) {
            error.textContent = result.data.description || result.data.message || 'Could not update quantity.';
            error.hidden = false;
          }
          lineEl.classList.remove('is-updating');
          return;
        }
        renderSections(result.data.sections);
        updateBubble(result.data.item_count);
      })
      .catch(function() {
        window.location.href = root + 'cart/change?line=' + line + '&quantity=' + quantity;
      })
      .then(function() {
        delete pending[line];
      });
  }

  document.addEventListener('click', function(evt) {
    var step = evt.target.closest && evt.target.closest('[data-pl-qty-step]');
    var remove = evt.target.closest && evt.target.closest('[data-pl-remove]');
    if (!step && !remove) return;
    var lineEl = (step || remove).closest('[data-pl-line]');
    if (!lineEl) return;
    evt.preventDefault();

    if (remove) {
      changeLine(lineEl, 0);
      return;
    }
    var input = lineEl.querySelector('[data-pl-qty-input]');
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-pl-qty-step'), 10));
    input.value = next;
    changeLine(lineEl, next);
  });

  document.addEventListener('change', function(evt) {
    var input = evt.target;
    if (!input.matches || !input.matches('[data-pl-qty-input]')) return;
    var lineEl = input.closest('[data-pl-line]');
    if (lineEl) changeLine(lineEl, Math.max(0, parseInt(input.value, 10) || 0));
  });

  // Enter in a quantity box updates that line instead of submitting the cart form to checkout.
  document.addEventListener('keydown', function(evt) {
    if (evt.key !== 'Enter' || !evt.target.matches || !evt.target.matches('[data-pl-qty-input]')) return;
    evt.preventDefault();
    evt.target.blur();
  });

  /* ---------- Cart changes made by other scripts (e.g. the upsell app's Add to cart) ---------- */

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var refreshTimer;

  function refreshAll() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function() {
      var ids = sectionIds();
      if (!ids.length) return;
      fetch(root + '?sections=' + ids.join(','))
        .then(function(response) { return response.json(); })
        .then(renderSections)
        .catch(function() {});
    }, 150);
  }

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var headers = (init && init.headers) || {};
      var own = typeof headers.get === 'function' ? headers.get('X-PL-Cart') : headers['X-PL-Cart'];
      var request = originalFetch.apply(this, arguments);
      if (!own && CART_MUTATION.test(url)) {
        request.then(function(response) { if (response.ok) refreshAll(); }).catch(function() {});
      }
      return request;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._plCartUrl = String(url || '');
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    if (this._plCartUrl && CART_MUTATION.test(this._plCartUrl)) {
      this.addEventListener('load', function() {
        if (this.status >= 200 && this.status < 300) refreshAll();
      });
    }
    return originalSend.apply(this, arguments);
  };

  /* ---------- Cart page: order note and sticky checkout bar ---------- */

  // The drawer's closed note shows a one-line preview of what's been typed.
  function syncNoteLabel(textarea) {
    var label = textarea.closest('details') && textarea.closest('details').querySelector('[data-pl-note-label]');
    if (!label) return;
    var note = textarea.value.trim();
    label.textContent = note ? 'Note: ' + note : 'Add a note to your order';
  }

  var noteTimer;
  document.addEventListener('input', function(evt) {
    if (!evt.target.matches || !evt.target.matches('[data-pl-cart-note]')) return;
    syncNoteLabel(evt.target);
    clearTimeout(noteTimer);
    var note = evt.target.value;
    noteTimer = setTimeout(function() {
      requestJSON(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      }).catch(function() {});
    }, 500);
  });

  // Phones: show the bottom checkout bar until the summary's own checkout button is on screen.
  var bar = document.querySelector('[data-pl-cart-bar]');
  if (bar) {
    var ticking = false;
    var check = function() {
      ticking = false;
      var checkout = document.querySelector('[data-pl-cart-checkout]');
      var visible = checkout && checkout.getBoundingClientRect().top < window.innerHeight - 40;
      bar.classList.toggle('is-hidden', !checkout || visible);
      document.documentElement.classList.toggle('pl-cart-bar-visible', !!checkout && !visible);
    };
    var request = function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    };
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    check();
  }
})();
